import { Link } from '@remix-run/react'
import React from 'react'
import { getUserImgSrc } from '#app/utils/misc.tsx'

type User = {
	id: string
	name: string | null
	username: string
	image: { id: string } | null
	roles?: {
		name: string
		permissions: { action: string; entity: string; access: string }[]
	}[]
}

interface UserImageProps {
	user: User | null
	className?: string
	isLink?: boolean
}

const UserImage: React.FC<UserImageProps> = ({
	user,
	className,
	isLink = true,
}) => {
	const containerClassName = `col-span-1 flex h-16 w-16 items-center justify-center overflow-hidden rounded-full border border-muted-foreground hover:cursor-pointer max-sm:h-12 max-sm:w-12 ${className}`
	const imgClassName =
		'h-full w-full scale-125 transform rounded-full object-cover object-center'
	return (
		<>
			{user ? (
				isLink ? (
					<Link
						to={`/users/${user.username}/reviews-added`}
						className={containerClassName}
						prefetch="intent"
					>
						<img
							className={imgClassName}
							alt={user.name ?? user.username}
							src={getUserImgSrc(user.image?.id)}
						/>
					</Link>
				) : (
					<div className={containerClassName}>
						<img
							className={imgClassName}
							alt={user.name ?? user.username}
							src={getUserImgSrc(user.image?.id)}
						/>
					</div>
				)
			) : (
				<div
					className={`col-span-1 flex h-16 w-16 items-center justify-center overflow-hidden rounded-full border border-muted-foreground max-sm:h-12 max-sm:w-12 ${className}`}
				>
					<img
						className="h-full w-full scale-50 transform rounded-full object-cover object-center"
						alt="Deleted user"
						src="/img/user.png"
					/>
				</div>
			)}
		</>
	)
}

export default UserImage
